<div class="{{getClass()}}" [matTooltip]="getTranslation() | translate"></div>
